module.exports = __webpack_public_path__ + "static/media/Illus-Employee_1@2x.a7b76724.png";